module.exports = __webpack_public_path__ + "img/HH2021plakatA4.f3e47ae5.jpg";